/** Inline pill indicator for tool execution status. */

import type { ToolExecution } from '../../types/expert';

interface ToolPillProps {
  tool: ToolExecution;
}

const TOOL_LABELS: Record<string, string> = {
  get_market_data: 'Checking market data',
  get_session_info: 'Checking session info',
  check_risk_rules: 'Checking risk rules',
  get_recent_trades: 'Reviewing recent trades',
  get_portfolio_summary: 'Loading portfolio',
  get_portfolio_performance: 'Analyzing performance',
  get_asset_signals: 'Scanning signals',
};

export function ToolPill({ tool }: ToolPillProps) {
  const label = TOOL_LABELS[tool.name] || tool.name.replace(/_/g, ' ');
  const isDone = tool.status === 'result';

  return (
    <span
      className={`inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full text-xs font-medium ${
        isDone
          ? 'bg-teal-500/10 text-teal-400'
          : 'bg-slate-700 text-slate-300'
      }`}
    >
      {!isDone && (
        <span className="w-1.5 h-1.5 bg-teal-400 rounded-full animate-pulse" />
      )}
      {isDone && (
        <svg className="w-3 h-3" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
          <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" />
        </svg>
      )}
      {isDone && tool.summary ? tool.summary : `${label}...`}
    </span>
  );
}
